var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"visitor"},[_c('section',[_c('div',{staticClass:"wrap"},[_vm._v("© 2019 Look4Trucks Inc. ")])])])}]

export { render, staticRenderFns }